import { createReducer, on } from '@ngrx/store';

import { initialTaricCodesState, ITaricCodesState } from './taricCodes.state';
import { TaricCodesLoaded, TaricCodesToogleNode, TaricCodesCollapseTree } from './taricCodes.actions';

export const initialState: ITaricCodesState = {
  tarics: [],
  taricTree: []
};

function formTree(taricList:ITaricCodesState['tarics']):ITaricCodesState['taricTree'] {
  const tree = [];
  const lookup = {};
  for (const code of taricList) {
    const obj:ITaricCodesState['taricTree'][0] = {
      id: code.id,
      value: code.value,
      code: code.code,
      description: code.description,
      parentId: code.parentId,
      selected: code.value ? code.selected : true,
      children: []
    };
    lookup[obj.id] = obj;
    if (obj.parentId === null) {
      tree.push(obj);
    } else {
      if (lookup[obj.parentId]) {
          lookup[obj.parentId].children.push(obj);
      }
    }
  }
  
  return tree;
}

const setTaricState = (state: ITaricCodesState, { ...props }: ITaricCodesState) => ({
  ...state,
  tarics: props.tarics,
  taricTree: formTree(props.tarics)
});

const collapseTaricTree = (state: ITaricCodesState) => {
  const newTaricList = state.tarics.map((taric)=>({...taric, selected: false }))
  return ({
    ...state,
    tarics: newTaricList,
    taricTree: formTree(newTaricList)
  })
};

const toogleNode = (state: ITaricCodesState, {...props}:{nodeId:number}) => {
  const newTaricList = state.tarics.map((taric)=>({...taric, selected: taric.id === props.nodeId ? !taric.selected : taric.selected }))
  return ({
    ...state,
    tarics: newTaricList,
    taricTree: formTree(newTaricList)
  })
};


const _taricCodesReducer = createReducer<ITaricCodesState>(
  initialTaricCodesState,
  on(TaricCodesLoaded, setTaricState),
  on(TaricCodesCollapseTree, collapseTaricTree),
  on(TaricCodesToogleNode, toogleNode)
);

export function taricCodesReducer(state: ITaricCodesState, action): ITaricCodesState {
  return _taricCodesReducer(state, action);
}
